import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Styles from "./style.module.css";
import { httpNonToken, endPoints } from "../../../globalConf/http-non-token";

const SelectDigital = ({ requestCopy, setRequestCopy, setServiceFlag }) => {
  const [digitalSection, setDigitalSection] = useState(true);
  const [digitalService, setDigitalService] = useState([]);
  const [selectedDigitalService, setSelectedDigitalService] = useState(
    requestCopy.digitalService
  );
  useEffect(() => {
    setSelectedDigitalService("");
    httpNonToken
      .get(`${endPoints.service}?type__id=3`)
      .then((response) => setDigitalService(response.data?.results || response.data || []))
      .catch((err) => console.error("Error fetching 360 services:", err));
    setSelectedDigitalService(requestCopy.digitalService);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    setSelectedDigitalService(parseFloat(e.target.id));
    setRequestCopy({
      digitalService: parseFloat(e.target.id),
      digitalServiceName: e.target.name,
    });
    setDigitalSection(!digitalSection);
    setServiceFlag(false);
  };

  const resetChoice = () => {
    setSelectedDigitalService("");
    setRequestCopy({ digitalServiceName: "", digitalService: "" });
    setDigitalSection(!digitalSection);
  };
  const getStyle = () => {
    let style = {};
    if (requestCopy.digitalService) style.backgroundColor = "#DAE8FC";
    else style.backgroundColor = "white";
    return style;
  };
  return (
    <>
      {digitalSection ? (
        <div
          style={getStyle()}
          className={`m-3 border rounded p-2  text-center  ${Styles.printing3d_section}`}
        >
          <img
            src="/images/global/360-printing.svg"
            className="my-3 w-50"
            alt="360 printing"
            onClick={() => setDigitalSection(!digitalSection)}
          />
          <h6 style={{ fontSize: "14px" }}>
            {`360 Digital Printing ${
              requestCopy.digitalServiceName
                ? `( ${requestCopy.digitalServiceName} )`
                : ""
            }`}
          </h6>
        </div>
      ) : (
        <div
          className={`bg-white m-3 border p-2 rounded ${Styles.printing3d_section}`}
        >
          <div className="border-bottom">
            <img
              src="/images/global/360-printing.svg"
              className="my-1 w_15 cursor-pointer"
              alt="360 printing"
              onClick={() => setDigitalSection(!digitalSection)}
            />
          </div>
          <div className="mt-2 ms-2 mx-1">
            <div className="d-flex justify-content-end">
              <Button
                size="small"
                onClick={resetChoice}
                variant="outlined"
                color="error"
              >
                Clear
              </Button>
            </div>
            {digitalService.map((printing, id) => (
              <div className="form-check  fn_sm fw-bold m-2 ls-1" key={id}>
                <input
                  className={`form-check-input ${Styles.select_printing}`}
                  type="radio"
                  name={printing.name}
                  id={printing.id}
                  checked={selectedDigitalService === printing.id}
                  value={selectedDigitalService}
                  onChange={(e) => handleChange(e)}
                />
                <label className="form-check-label" htmlFor={printing.id}>
                  {printing.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SelectDigital;
